import React, { useState, useEffect } from "react"
import Image from "next/image"
import AccountsLayout from "@/components/AccountsLayout/AccountsLayout"
import noImage from "@/public/images/image-missing.png"
import Button from "@/components/core/Button/Button"
import Sort from "@/components/ProductList/v2/Sort"
import styles from "@/components/MyServices/v1/MyServices.view/index.module.scss"
import { getShortenedUrl, getPresetUrl } from "@/utils/helper"
import useWindowResize from "@/hooks/useWindowResize"
import { getConfig } from "@/constants/config"

const MyServices = ({
  i18n = {},
  servicelist = {},
  isAuth = Boolean,
  user = {},
  data = [],
  logout = () => {},
  redirect = () => {},
  onSort = () => {},
  sorts = [],
  continueShoppingData = {},
  selectedSort = {},
  isLoading = false,
}) => {
  const [width] = useWindowResize()
  const [scene7AccountName, setScene7AccountName] = useState("")
  const [swatchUrl, setSwatchUrl] = useState("")
  const [siteName, setSiteName] = useState("")
  const [continueShoppingURL, setContinueShoppingURL] = useState("")
  const activeSort = query => onSort(query, "active")
  const pastSort = query => onSort(query, "past")
  const continueShoppingLabel = continueShoppingData.label
    ? continueShoppingData.label
    : i18n.shopServices

  const serviceImageWidth = 138
  const serviceImageHeight = 186
  useEffect(() => {
    getConfig().then(config => {
      const {
        general: { scene7AccountName = "", swatchUrl = "", siteName = "" },
      } = config
      setScene7AccountName(scene7AccountName)
      setSwatchUrl(swatchUrl)
      setSiteName(siteName)
      getContinueShoppingURL()
    })
  }, [])
  const getContinueShoppingURL = async () => {
    const { link } = continueShoppingData
    const urlLink = await getShortenedUrl(link)
    setContinueShoppingURL(`${urlLink}`)
  }

  const { myServices, activeServices, noServices, completedServices } = i18n
  const presetConfigsData = continueShoppingData?.presetConfigs
    ? JSON.parse(continueShoppingData?.presetConfigs)
    : {}

  return (
    <div className={`${styles.myserviceWrapper} myServiceView_wrapper`}>
      <AccountsLayout
        title={myServices}
        activeTab={4}
        isAuth={isAuth}
        user={user}
        i18n={i18n}
        logout={logout}
        data={data}
        redirect={redirect}
      >
        {servicelist.active.length > 0 ? (
          <div className="my-service__active-service">
            <div className="my-service__header">
              {servicelist.active.length > 0 ? (
                <h3 className="my-service__service-title">{activeServices}</h3>
              ) : (
                <h3 className="my-service__title"></h3>
              )}
              <Sort
                page="active-services"
                data={sorts}
                texts={i18n}
                onChange={activeSort}
                selectedSort={selectedSort}
                isMyserviceTab={true}
              />
            </div>
            {servicelist.active.map((item, i) => {
              const presetImageUrl = getPresetUrl(
                width,
                swatchUrl,
                item?.image,
                presetConfigsData,
                scene7AccountName
              )
              const imageUrl =
                siteName?.toLowerCase() === item?.brandName?.toLowerCase()
                  ? presetImageUrl
                  : item?.image
              return (
                <div key={i} className="my-service__list-box">
                  <Image
                    onError={e => (e.target.src = noImage?.src)}
                    src={imageUrl || noImage?.src}
                    width={serviceImageWidth}
                    height={serviceImageHeight}
                    alt="Service Image"
                  />
                  <div className="my-service__product-content">
                    {item.expirationDate && (
                      <span className="expires">{`EXPIRES ${item.expirationDate}`}</span>
                    )}
                    <p className="brand">{item.brandName}</p>
                    <p className="name">{item.name}</p>
                    <p className="purchased">{`Purchased : ${item.lastPurchasedOn}`}</p>
                  </div>
                </div>
              )
            })}
          </div>
        ) : (
          !isLoading && (
            <div className="active-service-sec">
              {servicelist.past.length > 0 && <h3>{`${activeServices}`}</h3>}
              <div>
                <p>{`${noServices}`}</p>
                <Button
                  className="gbh-data-layer"
                  role="link"
                  data-gbh-data-layer={`{"eventAction":"my account:services:active services:continue shopping","eventName":"my account:services:active services:continue shopping","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"continue shopping","internalLinkPosition":"my services","internalLinkType":"my account:navigation","internalLinkZoneName":"my account:services:active services","internalLinkURL":"n/a","clickInternalLinks":"true"}`}
                  type="black"
                  to={continueShoppingURL}
                  target={"_self"}
                  label={continueShoppingLabel}
                  useDefaultClass={true}
                  tag="anchor"
                />
              </div>
            </div>
          )
        )}
        {servicelist.past.length > 0 && (
          <div className="my-service__completed-service">
            <div className="my-service__header">
              <h3 className="my-service__title">{completedServices}</h3>
              <Sort
                page="past-services"
                data={sorts}
                texts={i18n}
                onChange={pastSort}
                selectedSort={selectedSort}
                isMyserviceTab={true}
              />
            </div>
            {servicelist.past.map((item, i) => {
              const presetImageUrl = getPresetUrl(
                width,
                swatchUrl,
                item?.image,
                presetConfigsData,
                scene7AccountName
              )
              const imageUrl =
                siteName?.toLowerCase() === item?.brandName?.toLowerCase()
                  ? presetImageUrl
                  : item?.image
              return (
                <div
                  key={i}
                  className="my-service__list-box my-service__past-list-box"
                >
                  <Image
                    onError={e => (e.target.src = noImage?.src)}
                    src={imageUrl || noImage?.src}
                    width={serviceImageWidth}
                    height={serviceImageHeight}
                    alt="Service Image"
                  />
                  <div className="my-service__product-content">
                    {item.expirationDate && (
                      <span className="expires">{`EXPIRED ${item.expirationDate}`}</span>
                    )}
                    <p className="brand">{item.brandName}</p>
                    <p className="name">{item.name}</p>
                    <p className="purchased">{`Purchased : ${item.lastPurchasedOn}`}</p>
                  </div>
                </div>
              )
            })}
          </div>
        )}
      </AccountsLayout>
    </div>
  )
}

export default MyServices
